import React from 'react'
import { useForm } from '../../forms/hocs/form.context'
import { Pill } from '../pill/pill'

export const RenderPills: React.FC<{ isFilterSelected: boolean }> = ({ isFilterSelected }) => {
    const { selectedMap, localFilterPills } = useForm()

    return isFilterSelected ? (
        <>
            {localFilterPills?.flatMap((facetGroup, groupIndex) =>
                facetGroup.pills.map((pill, pillIndex) => {
                    const filter = facetGroup.filter[0]
                    const selectedValues = selectedMap.get(filter)?.values || []
                    const isLast =
                        groupIndex === localFilterPills.length - 1 && pillIndex === facetGroup.pills.length - 1

                    return (
                        <Pill
                            key={`${filter}-${pill.value}`}
                            filters={facetGroup.filter}
                            selectedValues={selectedValues.filter((val) => val !== pill.value)}
                            text={pill.label || ''}
                            pills={facetGroup.pills}
                            isFilterSelected
                            id={isLast ? 'last-filter-pill' : undefined}
                            facetGroupName={pill.facetGroupName}
                        />
                    )
                })
            )}
        </>
    ) : null
}
